import axios from "../utils/axios";

export const getSimpleStepItems = async (params) => {
    const { data } = await axios.get("/simple-step-items", { params });
    return data;
};

export const getSimpleStepItemById = async (id) => {
    const { data } = await axios.get(`/simple-step-items/${id}`);
    return data;
};

export const createSimpleStepItem = async (itemData) => {
    const { data } = await axios.post("/simple-step-items", itemData);
    return data;
};

export const updateSimpleStepItem = async (id, itemData) => {
    const { data } = await axios.put(`/simple-step-items/${id}`, itemData);
    return data;
};

export const deleteSimpleStepItem = async (id) => {
    const { data } = await axios.delete(`/simple-step-items/${id}`);
    return data;
};

export const forceDeleteSimpleStepItem = async (id) => {
    const { data } = await axios.delete(`/simple-step-items/${id}/force-delete`);
    return data;
};

export const restoreSimpleStepItem = async (id) => {
    const { data } = await axios.post(`/simple-step-items/${id}/restore`);
    return data;
};

export const massDestroySimpleStepItems = async (data) => {
    const response = await axios.delete("/simple-step-items/mass-destroy", { data });
    return response.data;
};

export const massForceDeleteSimpleStepItems = async (data) => {
    const response = await axios.delete("/simple-step-items/mass-force-delete", { data });
    return response.data;
};

export const massRestoreSimpleStepItems = async (data) => {
    const response = await axios.post("/simple-step-items/mass-restore", data);
    return response.data;
};
